import { apiRequest } from '../services/ApiService.js';
import history from '../utility/common/History.js';

import {
  EMPLOYER_FIELD_CHANGED,
  EMPLOYER_UPDATE_SUCCESS,
  EMPLOYER_UPDATE_FAIL,

  AUTH_EMPLOYER,
  AUTH_EMPLOYER_SUCCESS,
  AUTH_EMPLOYER_FAIL,

  EMPLOYER_SET_DATA,
  EMPLOYER_SET_ERRORS,

  EMPLOYER_GET_PLAN_DETAILS,
  EMPLOYER_GET_PLAN_DETAILS_SUCCESS,
  EMPLOYER_GET_FUNDING_DETAILS_SUCCESS,
  EMPLOYER_GET_BANKING_SUCCESS,
  EMPLOYER_SET_BANKING_SUCCESS,
  EMPLOYER_BANKING_IMAGE_RESET,
  EMPLOYER_BANKING_IMAGE_ADD,
  EMPLOYER_BANKING_IMAGE_ADD_SUCCESS,
  EMPLOYER_BANKING_IMAGE_ADD_FAILED,

  EMPLOYER_EMPLOYEE_DIRECTORY,
  EMPLOYER_EMPLOYEE_DIRECTORY_SUCCESS,
  EMPLOYER_EMPLOYEE_DIRECTORY_FAIL,

  EMPLOYER_TERMINATE_SUCCESS,
  EMPLOYER_TERMINATE_FAIL,

  EMPLOYER_ENABLE_ONLINE_SUCCESS,
  EMPLOYER_ENABLE_ONLINE_FAIL,

  SNACKBAR_SET,
  AUTH_CLASSIFICATION_DIRECTORY,
  AUTH_CLASSIFICATION_DIRECTORY_SUCCESS,
  AUTH_CLASSIFICATION_DIRECTORY_FAIL,

  GENERAL_REQUEST_LOADING,
  GENERAL_REQUEST_LOADED,

  EMPLOYER_PENDING_EMPLOYEE_CLASS_CHANGE_SUCCESS,
  EMPLOYER_PENDING_EMPLOYEE_ONE_TIME_CHANGE_SUCCESS,

  AUTH_DIVISION_DIRECTORY,
  EMPLOYER_DIVISION_LIST_SUCCESS,
  EMPLOYER_EMPLOYEE_LIST_SUCCESS,

  EMPLOYER_NON_PLAN_ADMIN_CHANGE_SUCCESS,
  EMPLOYEE_TERMINATE_FAIL,
  EMPLOYEE_TERMINATE_SUCCESS,

  EMPLOYER_NEW_EMPLOYEE_REMOVE,
  EMPLOYER_NEW_EMPLOYEE_REMOVE_SUCCESS,
  EMPLOYER_NEW_EMPLOYEE_ADD,
  EMPLOYER_NEW_EMPLOYEE_ADD_SUCCESS,

  EMPLOYER_EMPLOYEES_ADD_SUCCESS,
  EMPLOYER_EMPLOYEES_ADD_FAIL,

  EMPLOYER_WELLNESS_SETUP_SUCCESS,
  EMPLOYER_WELLNESS_SETUP_FAIL,

  EMPLOYER_WELLNESS_DIRECTORY_SUCCESS,
  EMPLOYER_WELLNESS_DIRECTORY_FAIL,

  EMPLOYER_WELLNESS_MANAGE_SUCCESS,
  EMPLOYER_WELLNESS_MANAGE_FAIL,

  EMPLOYER_WELLNESS_TERMINATE_SUCCESS,
  EMPLOYER_WELLNESS_TERMINATE_FAIL,

  EMPLOYER_STRIPE_CARD_SUCCESS,
  EMPLOYER_STRIPE_CARD_FAIL,

  EMPLOYER_REFUND_BALANCE_SUCCESS,
  EMPLOYER_REFUND_BALANCE_FAIL,

  EMPLOYER_INSURANCE_FUNDING_SUCCESS,
  EMPLOYER_INSURANCE_FUNDING_FAIL,

  EMPLOYER_STRIPE_EMAIL_SUCCESS,
  EMPLOYER_STRIPE_EMAIL_FAIL
} from './types';

import { Validate, HSAMaxImageSize, inArray } from '../utility/common/GlobalHSA.js';

/*--------------------- Set Employer Data ----------------------*/

export const setEmployerData = (inputGroup, inputName, inputValue) => {
  return (dispatch) => {
    dispatch({ type: EMPLOYER_SET_DATA, datagroup: inputGroup, dataname: inputName, datavalue: inputValue });
  };
};

export const updateEmployerField = (fieldName, fieldValue) => {
  return (dispatch) => {
    dispatch({
      type: EMPLOYER_FIELD_CHANGED,
      fieldName: fieldName,
      fieldValue: fieldValue
    })
  };
};


/*--------------------- Set Employer Errors ----------------------*/

export const setEmployerErrors = (error, errors) => {
  return (dispatch) => {
    dispatch({ type: EMPLOYER_SET_ERRORS, error: error, errors: errors });
  };
};


/*---------------------------- Get Employer Data -----------------------------*/
export const authEmployerRequest = (adminId, employerId, token) => {
  return (dispatch) => {
    dispatch({ type: AUTH_EMPLOYER });

    const responseDispatches = { fail: AUTH_EMPLOYER_FAIL, success: AUTH_EMPLOYER_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    const endpoint = '/employer';
    const data = {
      bc: adminId,
      er: employerId,
      token: token
    };

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      true,
      false);
  };
};

/*---------------------------- Employer Update -----------------------------*/
export const employerUpdate = (employerData, erId, userId, token) => {
  return (dispatch) => {

    dispatch({ type: GENERAL_REQUEST_LOADING });

    employerValidation(dispatch, employerData, erId, userId, token);

  };
}

const employerValidation = (dispatch, employerData, erId, userId, token) => {

  let errors = {};

  if (!employerData) errors.GENERAL = 'Invalid employer data request';

  if (!erId) errors.GENERAL = 'Invalid employer request';

  if (!userId) errors.GENERAL = 'Invalid user request';

  if (!employerData.STREET1 || employerData.STREET1 === '' || employerData.STREET1 === null) errors.STREET1 = 'Please fill out the company address.';

  if (!employerData.CITY || employerData.CITY === '' || employerData.CITY === null) errors.CITY = 'Please fill out the company city.';

  if (employerData.POSTCODE && Validate(employerData.POSTCODE, 'isPostal') !== true) errors.POSTCODE = 'Invalid postal code format.';

  if (!employerData.POSTCODE || employerData.POSTCODE === '' || employerData.POSTCODE === null) errors.POSTCODE = 'Please fill out the company postal code.';

  if (!employerData.PROVINCE || employerData.PROVINCE === '' || employerData.PROVINCE === null) errors.PROVINCE = 'Please select a province.';

  if (employerData.TELEPHONE && Validate(employerData.TELEPHONE, 'isTelephone') !== true) errors.TELEPHONE = 'Invalid telephone format.';

  if (!employerData.TELEPHONE || employerData.TELEPHONE === '' || employerData.TELEPHONE === null) errors.TELEPHONE = 'Please fill out the company telephone.';

  if (employerData.CELLPHONE && Validate(employerData.CELLPHONE, 'isTelephone') !== true) errors.CELLPHONE = 'Invalid telephone format.';

  if (employerData.FAX && Validate(employerData.FAX, 'isTelephone') !== true) errors.FAX = 'Invalid telephone format.';

  if (Object.keys(errors).length > 0) {
    errors.GENERAL = (errors.GENERAL) ? errors.GENERAL : 'Please correct the missing information above';
    dispatch({
      type: EMPLOYER_UPDATE_FAIL,
      error: true,
      errors
    });
    dispatch({ type: GENERAL_REQUEST_LOADED });
    dispatch({
      type: SNACKBAR_SET,
      message: errors.GENERAL,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  } else {
    employerUpdateCall(dispatch, employerData, erId, userId, token);
  }

}

// ******************************************************************** //
/*  */
// ******************************************************************** //
const employerUpdateCall = (dispatch, employerData, erId, userId, token) => {

  const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_UPDATE_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const responseFunctions = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };
  const endpoint = '/employer/update';
  const data = {
    employer: employerData,
    erId: erId,
    userId: userId,
    token: token
  };

  apiRequest(dispatch,
    history,
    token,
    endpoint,
    data,
    responseDispatches,
    responseRedirects,
    showSnackBar,
    responseFunctions,
    true,
    false);

}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const newEmployeeRemove = (newEmployee) => {
  return (dispatch) => {
    dispatch({ type: EMPLOYER_NEW_EMPLOYEE_REMOVE, newEmployee });
    dispatch({ type: EMPLOYER_NEW_EMPLOYEE_REMOVE_SUCCESS });
  }
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const newEmployeeAdd = (newEmployee) => {
  return (dispatch) => {
    dispatch({ type: EMPLOYER_NEW_EMPLOYEE_ADD, newEmployee });
    dispatch({ type: EMPLOYER_NEW_EMPLOYEE_ADD_SUCCESS });
  }
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const activateBusinessOnlineClaims = (token, erId, eeId) => {
  return (dispatch) => {

    const responseDispatches = { fail: EMPLOYER_ENABLE_ONLINE_FAIL, success: EMPLOYER_ENABLE_ONLINE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const endpoint = '/employer/enable-online-claiming';
    const data = { erId: erId, eeId: eeId };

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);
  }
};
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const getEmployerStripeDetails = (token, erId) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_STRIPE_CARD_FAIL, success: EMPLOYER_STRIPE_CARD_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    const data = { erId: erId };
    const endpoint = '/employer/stripe/get';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);
  }
}
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerSetInsuranceFunding = (token, erId, eeId, newFundingOption) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_INSURANCE_FUNDING_FAIL, success: EMPLOYER_INSURANCE_FUNDING_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, newFundingOption: newFundingOption };
    const endpoint = '/employer/insurance-funding/set';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  }
}
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerCurrentInsuranceFunding = (token, erId, eeId) => {
  return (dispatch) => {

    const responseDispatches = { fail: EMPLOYER_INSURANCE_FUNDING_FAIL, success: EMPLOYER_INSURANCE_FUNDING_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };
    const data = { erId: erId, eeId: eeId };
    const endpoint = '/employer/insurance-funding/get';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);
  }
}
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerCurrentBalanceRequest = (token, erId, eeId) => {
  return (dispatch) => {

    const responseDispatches = { fail: EMPLOYER_REFUND_BALANCE_FAIL, success: EMPLOYER_REFUND_BALANCE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };
    const data = { erId: erId, eeId: eeId };
    const endpoint = '/employer/balance';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  }
}
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerBalanceRefundRequest = (token, erId, eeId, refundAmount) => {
  return (dispatch) => {

    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_REFUND_BALANCE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, refundAmount: refundAmount };
    const endpoint = '/employer/refund';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  }
}
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const fetchEmployerPlanDetails = (token, erId) => {
  return (dispatch) => {
    dispatch({ type: EMPLOYER_GET_PLAN_DETAILS });

    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_GET_PLAN_DETAILS_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    const data = { erId: erId };
    const endpoint = '/employer/plan-details/get';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);
  }
}
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const setEmployerStripeDetails = (token, erId, stripeToken) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_STRIPE_CARD_FAIL, success: EMPLOYER_STRIPE_CARD_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, stripeToken: stripeToken };
    const endpoint = '/employer/stripe/update';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);
  }
}
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const getEmployerStripeEmail = (token, erId) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_STRIPE_EMAIL_FAIL, success: EMPLOYER_STRIPE_EMAIL_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId };
    const endpoint = '/employer/stripe-email/get';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  }
}
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const setEmployerStripeEmail = (token, erId, stripeEmail) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_STRIPE_EMAIL_FAIL, success: EMPLOYER_STRIPE_EMAIL_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, stripeEmail: stripeEmail };
    const endpoint = '/employer/stripe-email/update';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);
  }
}
// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authEmployerTerminationRequest = (token, erId, userId, terminationReason, terminationCode) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_TERMINATE_FAIL, success: EMPLOYER_TERMINATE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: true };
    const data = { erId: erId, userId: userId, reason: terminationReason, option: terminationCode, confirm: true };
    const endpoint = '/employer/cancel-plan';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authEmployeeDirectoryRequest = (token, userId, erId) => {
  return (dispatch) => {

    dispatch({ type: EMPLOYER_EMPLOYEE_DIRECTORY });

    const responseDispatches = { fail: EMPLOYER_EMPLOYEE_DIRECTORY_FAIL, success: EMPLOYER_EMPLOYEE_DIRECTORY_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };
    const data = { erId: erId, userId: userId };
    const endpoint = '/employee/directory';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authClassificationDirectoryRequest = (token, userId, erId) => {
  return (dispatch) => {
    dispatch({ type: AUTH_CLASSIFICATION_DIRECTORY });

    const responseDispatches = { fail: AUTH_CLASSIFICATION_DIRECTORY_FAIL, success: AUTH_CLASSIFICATION_DIRECTORY_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };
    const data = { erId: erId, userId: userId };
    const endpoint = '/employer/classifications';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authClassificationAddRequest = (token, userId, erId, classificationName, amount, wellnessAmount, periodType) => {
  return (dispatch) => {

    const responseDispatches = { fail: AUTH_CLASSIFICATION_DIRECTORY_FAIL, success: AUTH_CLASSIFICATION_DIRECTORY_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, userId: userId, classificationName: classificationName, amount: amount, wellnessAmount: wellnessAmount, periodType: periodType };
    const endpoint = '/employer/classifications/add';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authClassificationEditRequest = (token, userId, erId, classificationId, amount, effective_date) => {
  return (dispatch) => {

    const responseDispatches = { fail: AUTH_CLASSIFICATION_DIRECTORY_FAIL, success: AUTH_CLASSIFICATION_DIRECTORY_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, userId: userId, classificationId: classificationId, amount: amount, effective_date: effective_date };
    const endpoint = '/employer/classifications/edit';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authClassificationDeletePendingRequest = (token, userId, erId, pendingLimitId) => {
  return (dispatch) => {

    const responseDispatches = { fail: AUTH_CLASSIFICATION_DIRECTORY_FAIL, success: AUTH_CLASSIFICATION_DIRECTORY_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, userId: userId, pendingLimitId: pendingLimitId };
    const endpoint = '/employer/classifications/delete-pending';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authClassificationDeleteRequest = (token, userId, erId, classificationId) => {
  return (dispatch) => {

    const responseDispatches = { fail: AUTH_CLASSIFICATION_DIRECTORY_FAIL, success: AUTH_CLASSIFICATION_DIRECTORY_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, userId: userId, classificationId: classificationId };
    const endpoint = '/employer/classifications/delete';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerWellnessSetupRequest = (token, userId, erId, wellness_categories, wellness_amounts) => {
  return (dispatch) => {

    const responseDispatches = { fail: EMPLOYER_WELLNESS_SETUP_FAIL, success: EMPLOYER_WELLNESS_SETUP_SUCCESS };
    const responseRedirects = { fail: null, success: '/wellness/setup/success' };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, userId: userId, wellness_categories: wellness_categories, wellness_amounts: wellness_amounts };
    const endpoint = '/employer/wellness/setup';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerWellnessManageUpdate = (token, userId, erId, wellness_categories, wellness_limits, remove_pending_changes) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_WELLNESS_MANAGE_FAIL, success: EMPLOYER_WELLNESS_MANAGE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, userId: userId, wellness_categories: wellness_categories, wellness_limits: wellness_limits, remove_pending_changes: remove_pending_changes };
    const endpoint = '/employer/wellness/manage';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerWellnessTerminate = (token, userId, erId, reason) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_WELLNESS_TERMINATE_FAIL, success: EMPLOYER_WELLNESS_TERMINATE_SUCCESS };
    const responseRedirects = { fail: null, success: '/wellness/setup' };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, userId: userId, reason: reason };
    const endpoint = '/employer/wellness/terminate';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerWellnessManageDirectoryRequest = (token, userId, erId) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_WELLNESS_DIRECTORY_FAIL, success: EMPLOYER_WELLNESS_DIRECTORY_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: false };
    const data = { erId: erId, userId: userId };
    const endpoint = '/employer/wellness';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authGetEmployerBankingFunding = (token, erId) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_GET_FUNDING_DETAILS_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };
    const data = { erId: erId };
    const endpoint = '/employer/company-funding/get';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authSetEmployerBankingFunding = (token, erId, businessFunding) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_GET_FUNDING_DETAILS_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: true };
    const data = { erId: erId, businessFunding: businessFunding };
    const endpoint = '/employer/company-funding/set';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authGetEmployerBankingDetails = (token, erId) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_GET_BANKING_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };
    const data = { erId: erId };
    const endpoint = '/employer/banking-details';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const authSetEmployerBankingDetails = (token, erId, transitNumber, institutionNumber, accountNumber, imageObj, eft_agreement) => {
  return (dispatch) => {
    
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_SET_BANKING_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = {fail: employerBankingImageReset, success:employerBankingImageReset};
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, 
      transitNumber: transitNumber, 
      institutionNumber: institutionNumber, 
      accountNumber: accountNumber, 
      eft_agreement: (eft_agreement)? 'Y' : 'N', 
      image: imageObj };
    const endpoint = '/employer/banking-details/save';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerBankingImageAdd = (imageObj) => {
  return (dispatch) => {
    dispatch({ type: EMPLOYER_BANKING_IMAGE_ADD, imageObj });
    processEmployerBankingImageAdd(dispatch, imageObj);
  }
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
const processEmployerBankingImageAdd = (dispatch, imageObj) => {

  let error = false;
  let errors = {};

  const responseDispatches = { fail: EMPLOYER_BANKING_IMAGE_ADD_FAILED, success: EMPLOYER_BANKING_IMAGE_ADD_SUCCESS };
  const responseRedirects = { fail: null, success: null };
  const showSnackBar = { fail: true, success: true };

  if (typeof imageObj !== "object") { error = true; errors.GENERAL = 'Invalid banking document'; }

  //check if valid file types
  if (!inArray(['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'], imageObj.type)) { error = true; errors.GENERAL = 'Invalid document type, please choose a JPEG, PNG, or PDF'; }

  //check if size is bigger than 4mb
  if (imageObj.size > HSAMaxImageSize) { error = true; errors.GENERAL = 'Maximum document size cannot exceed 5MB.'; }

  if (error === false) {
    employerBankImageUploadSuccess(
      dispatch,
      imageObj,
      'Banking document attached',
      responseDispatches.success,
      responseRedirects.success,
      showSnackBar.success
    );
  } else {
    errors.GENERAL = (errors.GENERAL) ? errors.GENERAL : 'Could not add banking document';
    employerBankImageUploadFail(
      dispatch,
      error,
      errors,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail
    );
  }

}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerBankingImageReset = () => {
  return (dispatch) => {
    dispatch({ type: EMPLOYER_BANKING_IMAGE_RESET });
  }
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerAddNewEmployees = (token, erId, employees) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_EMPLOYEES_ADD_FAIL, success: EMPLOYER_EMPLOYEES_ADD_SUCCESS };
    const responseRedirects = { fail: null, success: '/add-employee/success' };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: true };
    const data = { erId: erId, employees: employees };
    const endpoint = '/employer/add-employees';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerAddNewNonPlanAdmin = (token, erId, bcId, firstName, lastName, email) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_NON_PLAN_ADMIN_CHANGE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: true };
    const data = { erId: erId, bcId: bcId, firstName: firstName, lastName: lastName, email: email };
    const endpoint = '/employer/add-non-plan-admin';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerDeleteDivisionRequest = (token, userId, erId, divisionId) => {
  return (dispatch) => {
    dispatch({ type: AUTH_DIVISION_DIRECTORY });
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_EMPLOYEE_LIST_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: true };
    const data = { erId: erId, userId: userId, divisionId: divisionId };
    const endpoint = '/employer/remove-division';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerGetDivisions = (token, userId, erId) => {
  return (dispatch) => {
    dispatch({ type: AUTH_DIVISION_DIRECTORY });
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_DIVISION_LIST_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: false };
    const data = { erId: erId };
    const endpoint = '/employer/get-divisions';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerAddNewDivision = (token, erId, divisionName) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_DIVISION_LIST_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: false, success: true };
    const data = { erId: erId, divisionName: divisionName };
    const endpoint = '/employer/add-division';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerChangeNameRequest = (token, erId, eeId, firstName, lastName, spouse) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_EMPLOYEE_LIST_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, firstName: firstName, lastName: lastName, spouse: spouse };
    const endpoint = '/employer/change-employee-name';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerChangeEmployeeDivision = (token, erId, eeId, divisionId) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_EMPLOYEE_LIST_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, divisionId: divisionId };
    const endpoint = '/employer/change-employee-division';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerCancelTerminateEmployee = (token, erId, eeId, termDate) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYEE_TERMINATE_FAIL, success: EMPLOYEE_TERMINATE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, termDate: termDate };
    const endpoint = '/employee/cancel-terminate';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
}

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerTerminateEmployee = (token, erId, eeId, termDate) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYEE_TERMINATE_FAIL, success: EMPLOYEE_TERMINATE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, termDate: termDate };
    const endpoint = '/employee/terminate';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerToggleBCStatus = (token, erId, eeId, groupAdmin) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_EMPLOYEE_LIST_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, groupAdmin: groupAdmin };
    const endpoint = '/employer/toggle-bc-status';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerRemoveEmployeeClassChange = (token, erId, eeId, classificationId, changeDate) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_PENDING_EMPLOYEE_CLASS_CHANGE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, classificationId: classificationId, changeDate: changeDate };
    const endpoint = '/employer/remove-class-change';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerAddEmployeeClassChange = (token, erId, eeId, newClassificationId, changeDate) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_PENDING_EMPLOYEE_CLASS_CHANGE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, newClassificationId: newClassificationId, changeDate: changeDate };
    const endpoint = '/employer/add-class-change';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);
  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerAddEmployeeOneTimeChange = (token, erId, eeId, changeAmount, changeDate, changeReason) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_PENDING_EMPLOYEE_ONE_TIME_CHANGE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, changeAmount: changeAmount, changeDate: changeDate, changeReason: changeReason };
    const endpoint = '/employer/add-otc-change';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);

  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
export const employerRemoveEmployeeOneTimeChange = (token, erId, eeId, changeAmount, changeDate) => {
  return (dispatch) => {
    const responseDispatches = { fail: EMPLOYER_UPDATE_FAIL, success: EMPLOYER_PENDING_EMPLOYEE_ONE_TIME_CHANGE_SUCCESS };
    const responseRedirects = { fail: null, success: null };
    const responseFunctions = { fail: null, success: null };
    const showSnackBar = { fail: true, success: true };
    const data = { erId: erId, eeId: eeId, changeAmount: changeAmount, changeDate: changeDate };
    const endpoint = '/employer/remove-otc-change';

    apiRequest(dispatch,
      history,
      token,
      endpoint,
      data,
      responseDispatches,
      responseRedirects,
      showSnackBar,
      responseFunctions,
      false,
      false);
  };
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
const employerBankImageUploadSuccess = (
  dispatch,
  data,
  message,
  responseDispatch,
  responseRedirect,
  showSnackBar
) => {
  dispatch({
    type: responseDispatch,
    data,
  });
  if (showSnackBar === true) {
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      severity: 'notificationBarSuccess',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if (responseRedirect) history.push(responseRedirect);
};

// ******************************************************************** //
/*  */
// ******************************************************************** //
const employerBankImageUploadFail = (
  dispatch,
  error,
  errors,
  responseDispatch,
  responseRedirect,
  showSnackBar
) => {
  dispatch({
    type: responseDispatch,
    error,
    errors
  });
  if (showSnackBar === true) {
    dispatch({
      type: SNACKBAR_SET,
      message: errors.GENERAL,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if (errors.FORCE_LOGOUT) {
    // dispatch({
    //   type: LOGOUT,
    // });
    history.push('/logout');
  } else {
    if (responseRedirect) history.push(responseRedirect);
  }
};
